const queryParams = {
  billingPeriod: 'billingPeriod',
};

export default queryParams;
